// providerIcons — registro OFFLINE de los logos de proveedor de modelo usados en
// el selector "Modelo por defecto" de la pantalla de agentes.
//
// Decisión (design.md C.2): VIA es un portal corporativo que puede estar tras un
// firewall sin salida libre a Internet. Por eso NO usamos la resolución por red
// de Iconify (`<Icon icon="logos:…" />` que descarga el SVG de la API pública),
// sino que empaquetamos los datos del icono en el bundle. Importamos el set
// `logos` offline desde `@iconify-json/logos` y registramos SOLO los iconos de
// proveedor realmente usados con `addIcon`, de modo que `<Icon icon="logos:…" />`
// los resuelva localmente sin red.
//
// Nombres verificados contra `@iconify-json/logos/icons.json` (v offline, no la
// API de red). Confirmados existentes en el set `logos`:
//   - anthropic  -> logos:anthropic-icon   (ÚNICO en uso hoy; todos los modelos
//                   actuales son Claude/Anthropic)
//   - gemini     -> logos:google-gemini    (preparado para modelos futuros)
//   - openai     -> logos:openai-icon       (preparado para modelos futuros)
//   - aws        -> logos:aws               (preparado para modelos futuros)
//
// Si un proveedor no tiene icono registrado, `<Icon>` renderiza vacío sin romper
// el layout; el consumidor debe aplicar su propio fallback neutro (Hugeicons
// SparklesIcon) cuando PROVIDER_ICON[provider] no exista.
import { addIcon } from '@iconify/react';
import logos from '@iconify-json/logos/icons.json';

// Nombres de icono dentro del set `logos` (sin el prefijo `logos:`) para cada
// proveedor lógico. Mantener en inglés y en minúsculas.
const ICON_NAMES = {
  anthropic: 'anthropic-icon',
  gemini: 'google-gemini',
  openai: 'openai-icon',
  aws: 'aws',
};

// Registra en el runtime de Iconify cada icono de proveedor usando los datos
// empaquetados. Las dimensiones por icono caen al tamaño por defecto del set
// cuando el icono no define las suyas (patrón de @iconify-json).
function registerOfflineIcons() {
  Object.values(ICON_NAMES).forEach((iconName) => {
    const data = logos.icons[iconName];
    if (!data) return; // nombre inexistente en el set: se omite (fallback neutro aguas arriba)
    addIcon(`logos:${iconName}`, {
      body: data.body,
      width: data.width ?? logos.width,
      height: data.height ?? logos.height,
    });
  });
}

registerOfflineIcons();

// PROVIDER_ICON — mapa de proveedor lógico al nombre completo de icono Iconify
// (`logos:<nombre>`) que ya quedó registrado offline arriba. Se consume en
// InsightsAgents.jsx como <Icon icon={PROVIDER_ICON[provider]} … />.
export const PROVIDER_ICON = Object.fromEntries(
  Object.entries(ICON_NAMES).map(([provider, iconName]) => [provider, `logos:${iconName}`]),
);
